var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Tool from '../../common/tool';
import WmRequest from '../../common/request';
import Config from '../../common/config';
//告诉编译器此变量已声明
var LoginMethodList = /** @class */ (function () {
    function LoginMethodList(jumpToUrl, getWechatQrcode) {
        // 微信轮询定时器
        this.wechatCutDown = 300;
        this.wechatTimer = null;
        //获取手机号验证码倒计时
        this.phoneCutDown = 60;
        this.phoneTimer = null;
        // 获取邮箱号验证码倒计时
        this.emailCutDown = 60;
        this.emailTimer = null;
        // qq号登录
        this.qr_id = "";
        this.qqTimer = null;
        this.qqLoginWindow = null;
        this.getEmailFlag = false;
        this.getPhoneFlag = false;
        this.loginContainer = document.getElementById("login-method-list");
        this.loginDomList = this.loginContainer.querySelectorAll(".login-method-box");
        this.wmRequest = new WmRequest();
        this.jumpToUrl = jumpToUrl;
        this.getWechatQrcode = getWechatQrcode;
        this.init(this.jumpToUrl);
    }
    // 初始化
    LoginMethodList.prototype.init = function (jumpToUrl) {
        this.wechatLogin_polling(jumpToUrl);
        this.phoneLoginEventBind(jumpToUrl);
        this.emailLoginEventBind(jumpToUrl);
        this.enterKeyEvent();
        this.wechatEvent();
        // this.listenOnlineEvent();
    };
    // 登陆方式盒子展示
    LoginMethodList.prototype.showLoginBox = function (showFlag) {
        for (var i = 0; i < this.loginDomList.length; i++) {
            this.loginDomList[i].style.display = "none";
        }
        // 隐藏其他登录方式
        document.querySelectorAll(".login-bottom ul li").forEach(function (item) {
            item.classList.remove("hide");
        });
        switch (showFlag) {
            case "wechat":
                this.wechatLogin_polling(this.jumpToUrl);
                this.loginContainer.querySelector(".login-list-wechat").style.display = "block";
                // 显示微信登录方式
                document.querySelector(".login-method-wechat").classList.add("hide");
                break;
            case "phone":
                clearInterval(Number(this.wechatTimer));
                this.loginContainer.querySelector(".login-list-phone").style.display = "block";
                // 显示手机号登录方式
                document.querySelector(".login-method-phone").classList.add("hide");
                break;
            case "email":
                clearInterval(Number(this.wechatTimer));
                this.loginContainer.querySelector(".login-list-email").style.display = "block";
                // 显示邮箱登录方式
                document.querySelector(".login-method-email").classList.add("hide");
                break;
            case "close":
                clearInterval(Number(this.wechatTimer));
                break;
        }
    };
    // 网络监听
    // listenOnlineEvent(){
    //     let that = this;
    //     window.addEventListener("offline",function(){
    //         clearInterval(Number(that.wechatTimer));
    //     })
    // }
    //微信登录,轮询
    LoginMethodList.prototype.wechatLogin_polling = function (jumpToUrl) {
        var _this = this;
        var that = this;
        // let qrcodeOverdue = Tool.$_select(that.loginContainer, ".login-qrcode-overdue");
        that.wechatTimer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(that.wechatCutDown == 0)) return [3 /*break*/, 5];
                        Tool.$_select(that.loginContainer, ".login-qrcode .qrcode").classList.remove('show');
                        Tool.$_select(that.loginContainer, ".login-qrcode .loading").classList.add('show');
                        Tool.$_select(that.loginContainer, ".login-qrcode span").style.display = 'inline-block';
                        // qrcodeOverdue.style.display = "flex";
                        clearInterval(Number(that.wechatTimer));
                        if (!this.getWechatQrcode) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getWechatQrcode()];
                    case 2:
                        _a.sent();
                        that.wechatCutDown = 300;
                        that.wechatLogin_polling(jumpToUrl);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        that.wechatCutDown--;
                        // console.log(that.wechatCutDown)
                        that.wmRequest.ajax({
                            url: Config.WM_WECHAT_POLLING,
                            type: 'GET',
                            data: {}
                        }).then(function (res) {
                            if (res.code == 200) {
                                clearInterval(Number(that.wechatTimer));
                                if (jumpToUrl) {
                                    window.location.href = jumpToUrl; // 跳转其他页：如从/purchase登录跳转到/ExchangeCode
                                }
                                else {
                                    window.location.reload(); // 原地刷新
                                }
                            }
                            else {
                            }
                        }).catch(function (e) {
                            console.log(e);
                            clearInterval(Number(that.wechatTimer));
                        });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); }, 1000);
    };
    // 回车键监听
    LoginMethodList.prototype.enterKeyEvent = function () {
        var that = this;
        document.onkeydown = function (event) {
            var _a, _b;
            var e = event || window.event;
            if (e && e.keyCode == 13) { //回车键的键值为13
                if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id) === "phoneCodeInp") {
                    Tool.$_select(that.loginContainer, ".login-phone-btn").click();
                }
                else if (((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.id) === "emailCodeInp") {
                    Tool.$_select(that.loginContainer, ".login-email-btn").click();
                }
            }
        };
    };
    // 微信二维码过期刷新页面
    LoginMethodList.prototype.wechatEvent = function () {
        var that = this;
        var qrcodeOverdue = Tool.$_select(that.loginContainer, ".login-qrcode-overdue");
        qrcodeOverdue.addEventListener("click", function () {
            window.location.reload();
        });
    };
    //手机号登录事件集合
    LoginMethodList.prototype.phoneLoginEventBind = function (jumpToUrl) {
        var that = this;
        var loginPhoneDom = that.loginDomList[1];
        var phoneInpDom = Tool.$_select(loginPhoneDom, ".phoneInp");
        var phoneCodeDom = Tool.$_select(loginPhoneDom, ".phoneCodeInp");
        var PhoneCodeBtnDom = Tool.$_select(loginPhoneDom, ".getPhoneCode");
        var phoneInpError = Tool.$_select(loginPhoneDom, ".login-phoneInp-error");
        var phoneCodeError = Tool.$_select(loginPhoneDom, ".login-phoneCode-error");
        var phoneLoginBtn = Tool.$_select(loginPhoneDom, ".login-phone-btn");
        var phoneCutDown = Tool.$_select(loginPhoneDom, ".phoneCodeCutDown");
        // 手机号输入框
        phoneInpDom.addEventListener("input", function () {
            var phoneVal = this.value;
            phoneVal ? PhoneCodeBtnDom.classList.add("active") : PhoneCodeBtnDom.classList.remove("active");
            phoneInpError.innerText = '';
        });
        phoneInpDom.addEventListener("blur", function () {
            var phoneVal = this.value;
            if (!phoneVal) {
                phoneInpError.innerText = Config.Wm_tips_phone_empty;
                return;
            }
            if (!Tool.isPhoneNo(phoneVal)) {
                phoneInpError.innerText = Config.Wm_tips_phone_error;
                return;
            }
        });
        // 获取手机验证码
        PhoneCodeBtnDom === null || PhoneCodeBtnDom === void 0 ? void 0 : PhoneCodeBtnDom.addEventListener("click", function () {
            var phoneVal = phoneInpDom.value;
            if (!phoneVal) {
                phoneInpError.innerText = Config.Wm_tips_phone_empty;
                return;
            }
            if (!Tool.isPhoneNo(phoneVal)) {
                phoneInpError.innerText = Config.Wm_tips_phone_error;
                return;
            }
            that.getPhoneFlag = true;
            var params = {
                phone: String(phoneVal),
                timestamp: String(Date.now()),
                nonce_str: Tool.randomString(16),
            };
            //获取验证码请求
            that.wmRequest.ajax({
                url: Config.WM_GETPHONECODE,
                type: 'GET',
                data: __assign(__assign({}, params), { sign: that.generateSign(params) })
            }).then(function (res) {
                if (res.code == 200) {
                    PhoneCodeBtnDom.style.display = "none";
                    phoneCutDown.style.display = "block";
                    that.phoneTimer = setInterval(function () {
                        that.phoneCutDownEvent();
                    }, 1000);
                }
            });
        });
        // 手机验证码输入框
        phoneCodeDom.addEventListener("input", function () {
            var phoneCodeVal = this.value;
            phoneCodeError.innerHTML = '';
            phoneCodeVal ? phoneLoginBtn.classList.add("login-btn-active") : phoneLoginBtn.classList.remove("login-btn-active");
        });
        // 手机号登录按钮
        phoneLoginBtn === null || phoneLoginBtn === void 0 ? void 0 : phoneLoginBtn.addEventListener("click", function () {
            var _a;
            var phoneVal = phoneInpDom.value;
            var phoneCodeVal = (_a = Tool.$_select(loginPhoneDom, ".phoneCodeInp")) === null || _a === void 0 ? void 0 : _a.value;
            if (!this.classList.contains("login-btn-active"))
                return;
            if (!phoneVal) {
                phoneInpError.innerText = Config.Wm_tips_phone_empty;
                return;
            }
            if (!Tool.isPhoneNo(phoneVal)) {
                phoneInpError.innerText = Config.Wm_tips_phone_error;
                return;
            }
            if (!that.getPhoneFlag) {
                phoneCodeError.innerText = Config.Wm_tips_getCode;
                return;
            }
            // 手机号登录请求
            that.wmRequest.ajax({
                url: Config.WM_PHONE_LOGIN,
                type: "GET",
                data: {
                    // phone:phoneVal,
                    PhoneCode: phoneCodeVal,
                },
            }).then(function (res) {
                if (res.code == 200) {
                    phoneCodeError.innerHTML = '';
                    clearInterval(Number(that.phoneTimer));
                    if (jumpToUrl) {
                        window.location.href = jumpToUrl; // 跳转其他页：如从/purchase登录跳转到/ExchangeCode
                    }
                    else {
                        window.location.reload(); // 原地刷新
                    }
                }
                else {
                    phoneCodeError.innerHTML = res.msg;
                }
            });
        });
    };
    // 手机号获取验证码倒计时
    LoginMethodList.prototype.phoneCutDownEvent = function () {
        var that = this;
        var loginPhoneDom = that.loginDomList[1];
        var PhoneCodeBtnDom = Tool.$_select(loginPhoneDom, ".getPhoneCode");
        var phoneCutDown = Tool.$_select(loginPhoneDom, ".phoneCodeCutDown");
        var cutDownNum = phoneCutDown.querySelector("span");
        if (that.phoneCutDown == 0) {
            PhoneCodeBtnDom.style.display = "block";
            phoneCutDown.style.display = "none";
            that.phoneCutDown = 60;
            clearInterval(Number(that.phoneTimer));
        }
        else {
            that.phoneCutDown--;
            cutDownNum.innerText = that.phoneCutDown.toString();
        }
    };
    // 邮箱号登录事件集合
    LoginMethodList.prototype.emailLoginEventBind = function (jumpToUrl) {
        var that = this;
        var loginEmailDom = that.loginDomList[2];
        var emialInpDom = Tool.$_select(loginEmailDom, ".emailInp");
        var emialCodeDom = Tool.$_select(loginEmailDom, ".emailCodeInp");
        var emialCodeBtnDom = Tool.$_select(loginEmailDom, ".getEmailCode");
        var emialInpError = Tool.$_select(loginEmailDom, ".login-emailInp-error");
        var emialCodeError = Tool.$_select(loginEmailDom, ".login-emailCode-error");
        var emialLoginBtn = Tool.$_select(loginEmailDom, ".login-email-btn");
        var emailCutDown = Tool.$_select(loginEmailDom, ".emailCodeCutDown");
        // 邮箱号输入框
        emialInpDom === null || emialInpDom === void 0 ? void 0 : emialInpDom.addEventListener("input", function () {
            var emailVal = this.value;
            emailVal ? emialCodeBtnDom.classList.add("active") : emialCodeBtnDom.classList.remove("active");
            emialInpError.innerText = '';
        });
        emialInpDom === null || emialInpDom === void 0 ? void 0 : emialInpDom.addEventListener("blur", function () {
            var emailVal = this.value;
            if (!emailVal) {
                emialInpError.innerText = Config.Wm_tips_email_empty;
                return;
            }
            if (!Tool.isMail(emailVal)) {
                emialInpError.innerText = Config.Wm_tips_email_error;
                return;
            }
        });
        // 获取邮箱验证码
        emialCodeBtnDom === null || emialCodeBtnDom === void 0 ? void 0 : emialCodeBtnDom.addEventListener("click", function () {
            var _this = this;
            var emailVal = emialInpDom.value;
            if (!emailVal) {
                emialInpError.innerText = Config.Wm_tips_email_empty;
                return;
            }
            if (!Tool.isMail(emailVal)) {
                emialInpError.innerText = Config.Wm_tips_email_error;
                return;
            }
            that.getEmailFlag = true;
            //获取验证码请求
            that.wmRequest.ajax({
                url: Config.WM_GETEMAILCODE,
                type: "GET",
                data: {
                    Email: emailVal,
                }
            }).then(function (res) {
                if (res.code == 200) {
                    _this.style.display = "none";
                    emailCutDown.style.display = "block";
                    that.emailTimer = setInterval(function () {
                        that.emailCutDownEvent();
                    }, 1000);
                }
            });
        });
        // 邮箱验证码输入框
        emialCodeDom === null || emialCodeDom === void 0 ? void 0 : emialCodeDom.addEventListener("input", function () {
            var emailVal = this.value;
            emailVal ? emialLoginBtn.classList.add("login-btn-active") : emialLoginBtn.classList.remove("login-btn-active");
        });
        // 邮箱号登录按钮
        emialLoginBtn === null || emialLoginBtn === void 0 ? void 0 : emialLoginBtn.addEventListener("click", function () {
            var _a;
            var emailVal = emialInpDom.value;
            var emailCodeVal = (_a = Tool.$_select(loginEmailDom, ".emailCodeInp")) === null || _a === void 0 ? void 0 : _a.value;
            if (!this.classList.contains("login-btn-active"))
                return;
            if (!emailVal) {
                emialInpError.innerText = Config.Wm_tips_email_empty;
                return;
            }
            if (!Tool.isMail(emailVal)) {
                emialInpError.innerText = Config.Wm_tips_email_error;
                return;
            }
            if (!that.getEmailFlag) {
                emialCodeError.innerText = Config.Wm_tips_getCode;
                return;
            }
            // 邮箱号登录请求
            that.wmRequest.ajax({
                url: Config.WM_EMAIL_LOGIN,
                type: "GET",
                data: {
                    EmailCode: emailCodeVal,
                    // Email:emailVal,
                }
            }).then(function (res) {
                if (res.code == 200) {
                    emialCodeError.innerText = '';
                    clearInterval(Number(that.emailTimer));
                    if (jumpToUrl) {
                        window.location.href = jumpToUrl; // 跳转其他页：如从/purchase登录跳转到/ExchangeCode
                    }
                    else {
                        window.location.reload(); // 原地刷新
                    }
                }
                else {
                    emialCodeError.innerText = res.msg;
                }
            });
        });
    };
    // 邮箱验证码倒计时
    LoginMethodList.prototype.emailCutDownEvent = function () {
        var that = this;
        var loginEmailDom = that.loginDomList[2];
        var emialCodeBtnDom = Tool.$_select(loginEmailDom, ".getEmailCode");
        var emailCutDown = Tool.$_select(loginEmailDom, ".emailCodeCutDown");
        var cutDownNum = emailCutDown.querySelector("span");
        if (that.emailCutDown == 0) {
            emialCodeBtnDom.style.display = "block";
            emailCutDown.style.display = "none";
            that.emailCutDown = 60;
            clearInterval(Number(that.emailTimer));
        }
        else {
            that.emailCutDown--;
            cutDownNum.innerText = that.emailCutDown.toString();
        }
    };
    /** 与后端 `QqMobileLogin` / `qq_login_confirm` 配套；PC 扫码流程在手机 QQ WebView 中易失败或提示不支持 */
    LoginMethodList.prototype.isMobileQqLoginContext = function () {
        try {
            var ua = navigator.userAgent || '';
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|MQQBrowser|Mobile/i.test(ua);
        }
        catch (_) {
            return false;
        }
    };
    // qq登录
    LoginMethodList.prototype.qqLogin = function () {
        var _this = this;
        if (this.isMobileQqLoginContext()) {
            var q = window.location.search || '';
            // window.open(Config.WM_QQ_MOBILE_LOGIN + q, "_blank")
            window.location.href = Config.WM_QQ_MOBILE_LOGIN + q;
            return;
        }
        this.qqLoginWindow = window.open(Config.WM_QQ_LOGIN, "_blank");
        this.qqTimer = setInterval(function () {
            _this.qqLogin_polling();
        }, 1000);
    };
    //qq登录轮询
    LoginMethodList.prototype.qqLogin_polling = function (jumpToUrl) {
        var _a;
        var that = this;
        if ((_a = that.qqLoginWindow) === null || _a === void 0 ? void 0 : _a.closed) {
            // 关闭前请求一次是否扫码成功
            clearInterval(Number(that.qqTimer));
            that.wmRequest.ajax({
                url: Config.WM_QQ_POLLING,
                type: "POST",
                data: {}
            }).then(function (res) {
                if (res.code == 200) {
                    if (jumpToUrl) {
                        window.location.href = jumpToUrl; // 跳转其他页：如从/purchase登录跳转到/ExchangeCode
                    }
                    else {
                        window.location.reload(); // 原地刷新
                    }
                }
                else {
                    console.error(res.msg);
                    alert('QQ登录失败，请稍后重试！');
                }
            }).catch(function (e) {
                console.error(e);
                alert('QQ登录失败，请稍后重试！');
            });
            return;
        }
        that.wmRequest.ajax({
            url: Config.WM_QQ_POLLING,
            type: "POST",
            data: {}
        }).then(function (res) {
            if (res.code == 200) {
                clearInterval(Number(that.qqTimer));
                if (jumpToUrl) {
                    window.location.href = jumpToUrl; // 跳转其他页：如从/purchase登录跳转到/ExchangeCode
                }
                else {
                    window.location.reload(); // 原地刷新
                }
            }
        });
    };
    // 生成签名
    LoginMethodList.prototype.generateSign = function (param) {
        var data = JSON.stringify(Tool.objKeySort(param)) + Config.Wc_key;
        var sign = this.untilMd5(data).toUpperCase();
        return sign;
    };
    // md5加密
    LoginMethodList.prototype.untilMd5 = function (data) {
        return md5(data);
    };
    return LoginMethodList;
}());
export default LoginMethodList;
